/* eslint no-unused-expressions: 0 */
import React from 'react';
import classNames from 'classnames';
import FeaturedOrgs from './featuredOrgs';
import Pagination from '../../Pagination';
import Footer from '../../Footer.js';

import { COLORS, COMMUNITIES_TO_NAMES, CONGRESS_COLORS, IDS_TO_COMMUNITIES } from '../../../constants';
import iconClear from '../../../images/x-circle.png';
import iconClearRed from '../../../images/x-circle-red.png';
import Button from "../../Button";

const ListView = (props) => {
	const {
		categoryCount,
		categoryName,
		USstateName,
		districtName,
		currentPage,
		handleEvent,
		totalFilteredResults,
		searchResultsByCategory,
		searchResults,
		uiState,
		resetMap,
		isMobile,
		resultsExpanded,
		searchType,
	} = props;

	let filterCountPhrase = '';

	const filterApplied =
		categoryName !== '' ||
		USstateName !== 'State' ||
		districtName !== 'District' ||
		searchType !== '';

	let filterText = '';
	const currentSearchUItext = typeof uiState.currentSearch === 'undefined' ? '' : uiState.currentSearch;
	const isCountry = Object.prototype.hasOwnProperty.call(uiState.input, 'place_type') && uiState.input.place_type === 'country';
	const categoryUIname = COMMUNITIES_TO_NAMES[categoryName] || '';

	if (currentSearchUItext.indexOf('invalid zip code') > -1) {
		filterText = currentSearchUItext;
	}
	else {
		switch (uiState.filterType) {
			case 'location':
				categoryUIname !== ''
					? filterText = `${categoryUIname} results near ${currentSearchUItext}`
					: filterText = `results near ${currentSearchUItext}`

				// small fix for Puerto Rico
				isCountry && (filterText = filterText.replace('near', 'based in'));
				break;

			case 'keyword':
				if (currentSearchUItext.length) {
					categoryUIname !== ''
						? filterText = `${categoryUIname} results for "${currentSearchUItext}"`
						: filterText = `results for "${currentSearchUItext}"`;
				}
				else {
					filterText = 'results';
				}

				USstateName !== 'State' &&
				(filterText += ` based in ${USstateName}`,
					filterText += districtName === 'District' ? `` : `'s ${districtName}`);

				break;

			case 'category':
				filterText = `${categoryUIname} results`;

				searchType === 'keyword' &&
				(filterText += ` for "${currentSearchUItext}"`,
				uiState.input.validLocation === true &&
				(filterText = filterText.replace(' for ', ' near '),
					filterText = filterText.replace(/"/g, '')))

				if (searchType === 'place' || searchType === 'postcode') {
					filterText += ` near ${currentSearchUItext}`;
				}

				USstateName !== 'State' &&
				(filterText += ` based in ${USstateName}`,
					filterText += districtName === 'District' ? `` : `'s ${districtName}`);

				break;

			case 'region':
				categoryUIname !== ''
					? filterText = `${categoryUIname} results`
					: filterText = `results`;

				searchType === 'keyword' &&
				(filterText += ` for "${currentSearchUItext}"`)

				filterText += ` based in ${USstateName}`;
				filterText += districtName === 'District' ? `` : `'s ${districtName}`;
				break;

			default:
				currentSearchUItext.length
					? filterText = `results for "${currentSearchUItext}"`
					: filterText = 'results';
		}
	}

	if (filterText.indexOf('invalid zip code') < 0) {
		filterText = `${categoryCount} ${filterText}`;
	}


	// if only 1 results, ensure the search summary is in singular
	categoryCount === 1 && (filterText = filterText.replace('results', 'result'));

	// eslint-disable-next-line consistent-return
	function zeroResults() {
		if (Object.keys(searchResultsByCategory).length !== 0) {
			let value = true;

			for (let i = 0; i < COLORS.length; i++) {

				if (searchResultsByCategory[IDS_TO_COMMUNITIES[i]].length > 0) {
					value = false;
				}
			}
			return true;
		}
	}


	const isLoading = searchResults.length >= 0 || zeroResults();

	filterCountPhrase = isLoading ? filterText : 'Results Loading...';

	return (
		<div>
			<div className="organizations__results-total">
				{isMobile && (
					<Button
						handleClick={() => {
							handleEvent({
								action: 'toggle',
								type: 'ListView',
								name: 'results',
							});
						}}
						aria-expanded={resultsExpanded}
						buttonStyles={classNames('toggle results', {
							open: uiState.showListView,
						})}
					>
						<div className={classNames('chevron', uiState.showListView ? 'up' : '')}/>
						<span>List View</span>
						<h1 id="map-main-h1" className={classNames('style-italic', categoryCount < 1 ? 'red' : '')} tabIndex="-1">{filterCountPhrase}</h1>
					</Button>
				)}
				{!isMobile && (
					<div style={{width: '100%'}}>
						<h1 id="map-main-h1" className={classNames('style-italic', categoryCount < 1 ? 'red' : '')} tabIndex="-1">{filterCountPhrase}</h1>
						<Button
							handleClick={() => {
								resetMap();
							}}
							buttonStyles={classNames('icon clear-button icon-left',
								{
									'': isLoading,
									'hide-all': !filterApplied,
								})}
							alttext="Clear Search"
							type="submit"
						>
							<img src={categoryCount < 1 ? iconClearRed : iconClear} className="icon-x results" alt="search icon"/>
						</Button>
					</div>
				)}
			</div>
			<ul>{
				console.log(searchResults)}
				{searchResults.map((org, index) => (
					typeof org != 'undefined' && (
						<FeaturedOrgs
							key={`${org.properties.id}_${index}`}
							id={org.properties.id}
							company={org.properties.name}
							city={org.properties.city}
							state={org.properties.state}
							mission={org.properties.mission}
							is_featured={org.properties.is_featured}
							story={org.properties.story}
							color={CONGRESS_COLORS[Number(org.properties.category_id)]}
							index={index}
							fullname={COMMUNITIES_TO_NAMES[IDS_TO_COMMUNITIES[org.properties.category_id]]}
							currentPage={currentPage}
							featuredOrgs={uiState.featuredOrgs}
						/>
					)
				))
				}
			</ul>
			<Pagination
				{...{currentPage, handleEvent}}
				show
				total={totalFilteredResults}
			/>
			<Footer
				showSocial={false}
				styleType="force-mobile"
			/>


		</div>
	);
};

export default ListView;
